<template>
  <modal
    :title="'Pin Appointment'"
    class-name="small-modal"
    @hide-modal="handleDismiss"
  >
    <div>
      <p class="mb-4">
        Are you sure you want to pin this appointment to
        {{ technicianName }}?
      </p>
      <span class="label"> Reason (Optional) </span>
      <TextArea v-model="pinnedReason"></TextArea>
    </div>
    <template #footer>
      <div class="modal-footer d-flex justify-content-end" style="gap: 0.5rem">
        <SeraButton
          type="secondary"
          data-cy="dont-notify-btn"
          :disabled="saving"
          @click="handleDontNotify"
        >
          Don't Notify
        </SeraButton>
        <SeraButton
          data-cy="notify-btn"
          :disabled="saving"
          @click="handleNotify"
        >
          <span v-if="!saving">Notify Customer</span>
          <Spinner v-else message="Saving..." />
        </SeraButton>
      </div>
    </template>
  </modal>
</template>

<script>
import { mapActions } from "vuex";

import SeraButton from "@/components/Button.vue";
import Modal from "@/components/Modal.vue";
import Spinner from "@/components/Spinner.vue";
import TextArea from "@/components/TextArea.vue";
import useVuelidate from "@vuelidate/core";
export default {
  components: {
    Modal,
    SeraButton,
    Spinner,
    TextArea
  },
  props: {
    appointmentId: {
      type: [String, Number],
      default: null
    },
    technicianId: {
      type: Number,
      default: null
    },
    technicianName: {
      type: String,
      default: null
    },
    pendingTimePayload: {
      type: Object,
      default: null
    },
    multiTechIds: {
      type: Array,
      default: null
    }
  },
  emits: ["hide-modal"],
  setup() {
    return {
      v$: useVuelidate()
    };
  },
  data() {
    return {
      pinnedReason: "",
      saving: false,
      resolved: false
    };
  },
  methods: {
    ...mapActions(["updateAppointmentEvent", "assignAppointmentEvent"]),
    handleNotify() {
      this.submitUpdate(false);
    },
    handleDontNotify() {
      this.submitUpdate(true);
    },
    handleDismiss() {
      if (this.resolved) return;
      this.submitUpdate(true);
    },
    submitUpdate(skipNotifications) {
      this.resolved = true;
      this.saving = true;

      if (this.multiTechIds) {
        this.submitMultiTechUpdate(skipNotifications);
      } else {
        this.submitSingleTechUpdate(skipNotifications);
      }
    },
    submitSingleTechUpdate(skipNotifications) {
      const payload = {
        appointmentId: this.appointmentId,
        technician_profile_id: this.technicianId,
        pinned_reason: this.pinnedReason,
        skip_notifications: skipNotifications,
        ...this.pendingTimePayload
      };
      this.updateAppointmentEvent(payload)
        .then(() => {
          window.notify.success("Appointment updated");
        })
        .finally(() => {
          this.saving = false;
          this.$emit("hide-modal");
        });
    },
    submitMultiTechUpdate(skipNotifications) {
      const timePromise = this.pendingTimePayload
        ? this.updateAppointmentEvent({
            appointmentId: this.appointmentId,
            skip_notifications: skipNotifications,
            ...this.pendingTimePayload
          })
        : Promise.resolve();

      timePromise
        .then(() =>
          this.assignAppointmentEvent({
            appointmentId: this.appointmentId,
            technician_profile_ids: this.multiTechIds,
            pinned_reason: this.pinnedReason
          })
        )
        .then(() => {
          window.notify.success("Appointment updated");
        })
        .finally(() => {
          this.saving = false;
          this.$emit("hide-modal");
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
